import Cookies from 'js-cookie'

function getCookieStr() {
    return document.cookie;
}

export default {
    get: Cookies.get,
    set: Cookies.set,
    getCookieStr
};
